export const environment = {
  production: true,
  api_key: 'INrdQskb0DZehd3cPg2cx31QNuCXVG09b5EY29yanw0VfsQarm',
};
